import { Component } from '@angular/core';

@Component({
  selector: 'app-media-object-content',
  template: `
    <ng-content></ng-content>
  `,
})
export class MediaObjectContentComponent {}
